<configuration-option-primary-tag-filter
  [isCollapsed]="false"
  [formValues$]="configFormValues$"
  [discoveryAreaConfigHasValue$]="discoveryAreaConfigHasValue$"
  (onSubmit)="onSubmit($event)"
></configuration-option-primary-tag-filter>

<configuration-option-secondary-tag-filter
  *ngIf="!(discoveryAreaConfigHasValue$ | async)"
  [isCollapsed]="true"
  [formValues$]="configFormValues$"
  (onSubmit)="onSubmit($event)"
></configuration-option-secondary-tag-filter>

<configuration-option-filternaming-branding-card
  *ngIf="!(discoveryAreaConfigHasValue$ | async)"
  [isCollapsed]="true"
  [formValues$]="configFormValues$"
  (onSubmit)="onSubmit($event)"
></configuration-option-filternaming-branding-card>

<configuration-option-tagsearch-placeholder-branding-card
  [isCollapsed]="true"
  [formValues$]="configFormValues$"
  (onSubmit)="onSubmit($event)"
></configuration-option-tagsearch-placeholder-branding-card>
